
const messages = {
  en: {
    cliente: {
      title: 'Client Management',
      menuTitle: 'Clients',
      subtitle: 'View, search, create, edit, and delete Clients',
      creating: 'Creating Client',
      editing: 'Editing Client',
      deleting: 'Deleting Client',
      showing: 'Showing Client',
      documentosVentaReminderTitle: 'Data on sales documents',
      documentosVentaReminderText:
        'The business name, document, tax condition, address and contact details you enter here are what will appear on budgets, delivery notes and invoices for this customer when you generate them. Please verify before continuing.',
      labels: {
        tipoDocumento: 'Document Type',
        numeroDocumento: 'Document Number',
        razonSocial: 'Company name (unique)',
        nombrePersona: 'Name (unique)',
        email: 'Email',
        telefono: 'Phone',
        domicilio: 'Address',
        piso: 'Floor',
        departamento: 'Apartment',
        codigoPostal: 'Postal Code',
        condicionIVA: 'Tax Condition',
        activo: 'Active',
        listaPreciosVentaDefault: 'Default sales price list',
      },
      messages: {
        ingreseNumeroDocumento: 'Please enter a document number',
        documentoInvalido: 'Invalid document format for the selected type',
      },
    },
  },
  es: {
    cliente: {
      title: 'Administración de Clientes',
      menuTitle: 'Clientes',
      subtitle: 'Ver, buscar, crear, editar, y borrar Clientes',
      creating: 'Creando Cliente',
      editing: 'Modificando Cliente',
      deleting: 'Eliminando Cliente',
      showing: 'Detalles de Cliente',
      documentosVentaReminderTitle: 'Datos en comprobantes de venta',
      documentosVentaReminderText:
        'La razón social, documento, condición IVA, domicilio y datos de contacto que cargás acá son los que van a figurar en presupuestos, remitos y facturas de este cliente cuando los generes. Verificá que estén bien antes de continuar.',
      labels: {
        tipoDocumento: 'Tipo de Documento',
        numeroDocumento: 'Número de Documento',
        razonSocial: 'Razón social (única)',
        nombrePersona: 'Nombre (único)',
        email: 'Email',
        telefono: 'Teléfono',
        domicilio: 'Domicilio',
        piso: 'Piso',
        departamento: 'Departamento',
        codigoPostal: 'Código Postal',
        condicionIVA: 'Condición IVA',
        activo: 'Activo',
        listaPreciosVentaDefault: 'Lista de precios por defecto',
      },
      messages: {
        ingreseNumeroDocumento: 'Por favor ingrese un número de documento',
        documentoInvalido: 'Formato de documento inválido para el tipo seleccionado',
      },
    },
  },
  pt: {
    cliente: {
      title: 'Administração de Clientes',
      menuTitle: 'Clientes',
      subtitle: 'Ver, buscar, criar, editar e excluir Clientes',
      creating: 'Criando Cliente',
      editing: 'Editando Cliente',
      deleting: 'Excluindo Cliente',
      showing: 'Detalhes do Cliente',
      documentosVentaReminderTitle: 'Dados nos documentos de venda',
      documentosVentaReminderText:
        'A razão social, documento, condição de IVA, endereço e contatos informados aqui são os que aparecerão em orçamentos, remessas e faturas deste cliente quando você os gerar. Confira antes de continuar.',
      labels: {
        tipoDocumento: 'Tipo de Documento',
        numeroDocumento: 'Número do Documento',
        razonSocial: 'Razão social (única)',
        nombrePersona: 'Nome (único)',
        email: 'Email',
        telefono: 'Telefone',
        domicilio: 'Endereço',
        piso: 'Andar',
        departamento: 'Apartamento',
        codigoPostal: 'Código Postal',
        condicionIVA: 'Condição de IVA',
        activo: 'Ativo',
        listaPreciosVentaDefault: 'Lista de preços padrão',
      },
      messages: {
        ingreseNumeroDocumento: 'Por favor, insira um número de documento',
        documentoInvalido: 'Formato de documento inválido para o tipo selecionado',
      },
    },
  }
}

export default messages
